/** @format */
import angular from 'angular';
import _ from 'lodash';
import { decimalNumberFilterModule } from '../number/decimalNumber.filter';
import { TooltipComponent } from '../tooltip/tooltip.component';
import moduleContentApplicationTpl from './moduleContentApplicationStructure.tpl.html';

export const moduleContentApplicationStructureModule = 'sis-components.applications.moduleContentApplicationStructure';

(function () {
    angular
        .module(moduleContentApplicationStructureModule, [decimalNumberFilterModule, TooltipComponent.downgrade.moduleName])

        .component('moduleContentApplicationStructure', {
            template: moduleContentApplicationTpl,
            controller: moduleContentApplicationController,
            controllerAs: 'ctrl',
            bindings: {
                module: '<',
                selectedCourseUnits: '<',
                selectedCourseUnitAttainmentsByGroupId: '<',
                selectedModules: '<',
                selectedModuleAttainmentsByGroupId: '<',
                selectedCustomCourseUnitAttainments: '<',
                selectedCustomModuleAttainments: '<',
                selectedGroupingModules: '<',
                selectedCustomStudyDrafts: '<',
                gradeScalesById: '<',
            },
        });

    function moduleContentApplicationController() {
        const ctrl = this;

        ctrl.$onChanges = () => {
            ctrl.customStudyDraftsById = _.keyBy(ctrl.selectedCustomStudyDrafts, 'id');
            ctrl.customCourseUnitAttainmentsByCustomStudyDraftId = _.chain(ctrl.selectedCustomCourseUnitAttainments)
                .filter(ccua => !!ccua.customStudyDraftId)
                .keyBy('customStudyDraftId')
                .value();

            ctrl.effectiveCustomStudyDrafts = _.filter(
                ctrl.selectedCustomStudyDrafts,
                csd => !_.get(ctrl.customCourseUnitAttainmentsByCustomStudyDraftId, csd.id),
            );
        };

        ctrl.getRelatedCustomStudyDraftForCustomCourseUnitAttainment = customCourseUnitAttainment => {
            if (!customCourseUnitAttainment.customStudyDraftId) {
                return null;
            }
            return _.get(ctrl.customStudyDraftsById, customCourseUnitAttainment.customStudyDraftId);
        };
    }
})();
